<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="8">
                        <span class="title">渠道码名称:</span>
                        <!-- 搜索渠道码名称 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入渠道码名称"
                            class="handle-input mr10"
                            @keyup.enter.native="searchPromotionLabelLists"
                        ></el-input>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchPromotionLabelLists">搜索</el-button>
            <el-button @click="add_isShow = !add_isShow">添加标签</el-button>
          


            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
           
            <el-table-column label="标签名称" prop="name" min-width="130"> </el-table-column>

            <el-table-column label="城市" prop="city.name" min-width="180"> </el-table-column>

            <el-table-column label="创建时间" prop="time.YmdHis"> </el-table-column>
          
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
        <!-- 添加组件 -->
        <addPromotionLabel :isShow="add_isShow" @onSubmit="searchPromotionLabelLists"></addPromotionLabel>
        
    </div>
</template>

<script>
var _this;
import addPromotionLabel from './addPromotionLabel.vue';


export default {
    components: {
        addPromotionLabel
    
    },
    data() {
        return {
            add_isShow: false,
            detail_isShow: false,
            srcList: [],
            detailData: '',

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                // promotion_label_code_array: ["PRLA655F00839D89197", "PRLA655F008B4B21897"],
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchPromotionLabelLists();
    },

    methods: {
        getDetail(val) {
            _this.detail_isShow = !_this.detail_isShow;
            _this.detailData = val.promotion_label_code;
            console.log(_this.detailData,'_this.detailData');
        },
       
        searchPromotionLabelLists() {
            _this.search_data.page = 1;
            _this.promotionLabelLists();
        },

        promotionLabelLists() {
            _this
                .$post('/promotion/promotionLabelLists', _this.search_data)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                    _this.srcList.length = 0;
                    for (let i = 0; i < res.data.length; i++) {
                        _this.srcList.push(res.data[i].qrcode_hash);
                        _this.srcList.push(res.data[i].qrcode);
                    }
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.promotionLabelLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
